import { Column, Stack } from 'src/components-v2/Layout';

const Header = ({ children }: { children: React.ReactNode }) => {
  return (
    <Column xs={24} md={12} lg={8} lgOffset={2}>
      <Stack
        direction={{ xs: 'row', md: 'column' }}
        gap={{
          md: 5,
        }}
        sx={{
          height: '100%',
        }}
      >
        <Stack
          gap={{
            xs: 1,
            md: 3,
          }}
          sx={{
            img: { mt: '40px', display: { xs: 'none', md: 'inline-block' } },
            '& p:nth-last-of-type(1):empty': {
              display: 'none',
            },
          }}
        >
          {children}
        </Stack>
      </Stack>
    </Column>
  );
};

export default Header;
